import find from 'lodash-es/find'
import * as React from 'react'

import { Site } from '../../../../../common/constants/siteList'
import { getCurrentSiteFromDomain } from '../../../../../common/utils/sites'
import sitesConfig from '../../../../../config/sites'
import { IItem } from '../../../../../typings/searchResults'
import { ISeoItem } from '../../../../../typings/seoMetadata'
import Button from '../../../../v0/components/button'
import ItemPreviewer from '../../../components/itemPreviewer'
import ItemThumbnailCarousel from '../itemThumbnailCarousel'
import SectionDescription from '../sectionDescription'

import * as styles from './freeItemSection.module.css'

const FreeItemSection = ({
  name,
  items,
  metadata,
  isSignedIn,
  videoMuted,
  muteVideo,
  reportItemClick,
  currentSite
}: {
  name: string
  items: IItem[]
  metadata: ISeoItem
  isSignedIn: boolean
  videoMuted: boolean
  muteVideo: () => any
  reportItemClick: (index: number, item: IItem, listName: string) => any
  currentSite: Site
}) => {
  return (
    <div data-test-selector="freeItemSection">
      <SectionDescription metadata={metadata} HTag="h3" />
      <ItemThumbnailCarousel justifyContent={'center'}>
        {items
          // item.site === 'themeforest.net'
          .sort(
            (a, b) =>
              getCurrentSiteFromDomain(a.site) === currentSite ? -1 : 1
          )
          .map((item, index) => {
            const siteConfig =
              item.site &&
              find(sitesConfig, config => config.domain === item.site)
            const siteName = siteConfig && siteConfig.name

            return (
              <ItemPreviewer
                item={item}
                key={item.id}
                annotation={siteName}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
                onClick={() => reportItemClick(index, item, name)}
              />
            )
          })}
      </ItemThumbnailCarousel>
      {!isSignedIn && (
        <div className={styles.buttonSection}>
          <Button primary href="/sign_up">
            Sign Up
          </Button>
        </div>
      )}
    </div>
  )
}

export default FreeItemSection
